<img translate="no" *ngIf="connectionType" [src]="appContext.connectionImage(connectionType)" [width]="width" [ngClass]="cssClass"
     [alt]="appContext.connectionName(connectionType)">